import R2Dom from "../helpers/R2Dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, ScrollTrigger);

R2Dom.Methods.dotsAnimate = function (_this) {
    var myElement = _this;
    var delay = 0;
    var elementsParent = myElement.parentElement.parentElement;

    if(myElement.getAttribute('data-delay') && parseInt(myElement.getAttribute('data-delay')) > 0) {
        delay = parseInt(myElement.getAttribute('data-delay'));
    }

    ScrollTrigger.create({
        trigger: _this,
        start: "top 80%", // Start when the element is in the viewport
        onEnter: () => {
            // Add the class
            setTimeout(() => {
                _this.classList.remove("paused");
                _this.classList.add("play");
            }, delay);

            setTimeout(() => {
                _this.classList.remove("play");
            }, (300 * (elementsParent.children.length * 2 - 1)) + delay);
        },
        toggleActions: "play none none none", // Only triggers once on scroll
    });
}